



import { __ } from "bits/intl"
import ajax from "bits/ajax"
export default
  props:
    status:
      default: "following"
    targetUserId: Number
  computed:
    buttonText: ->
      if this.status is "following" then __("Following") else __("Follow")
  methods:
    follow: ->
      self = this
      ajax("/api/user_follows.json",
        method: "POST"
        dataType: "json"
        data:
          user_id: self.targetUserId
      ).then(->
        self.status = "following"
      ).catch(->
        alert __("Oops! Something went wrong. Please try again.")
      )
    unfollow: ->
      self = this
      ajax("/api/user_follows.json",
        method: "DELETE"
        dataType: "json"
        data:
          user_id: self.targetUserId
      ).then(->
        self.status = "notfollowing"
      ).catch(->
        alert __("Oops! Something went wrong. Please try again.")
      )
    handleClick: ->
      if this.status is "following"
        this.unfollow()
      else
        this.follow()
